<div class="modal">
  <button class="close-btn btn" (click)="closeModal()">
    <svg class="icon">
      <use xlink:href="#large-cross"></use>
    </svg>
  </button>

  <div class="head">
    <h3 class="title">
      {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.PRIVACY_MODAL.TITLE' | translate }}
    </h3>
    <p class="subtitle">
      {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.PRIVACY_MODAL.SUBTITLE' | translate }}
    </p>
  </div>

  <app-scrollbar class="scrollbar" [vertical]="true" [size]="'standard'" [visibility]="'native'">
    <div [formGroup]="formGroup" class="content">
      <div class="section">
        <h4 class="title">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.PRIVACY_MODAL.COUNTRY_SELECT.TITLE' | translate }}
        </h4>
        <app-input-search-selection
          [options]="countries"
          formControlName="geoCode"
          [selectionDropdownInfo]="selectionInfo"
          [placeholder]="'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.PRIVACY_MODAL.COUNTRY_SELECT.PLACEHOLDER'"></app-input-search-selection>
      </div>

      <div class="section">
        <h4 class="title">Settings</h4>

        <app-toggle
          [settings]="teamAccessSettings"
          [disabled]="teamAccessSettings.disabled"
          (onToggleItem)="onTeamAccessToggle()"></app-toggle>
      </div>
    </div>
  </app-scrollbar>

  <div class="actions">
    <button class="link new-link--back" (click)="closeModal()">
      {{ 'GENERAL.CANCEL' | translate }}
    </button>

    <button
      class="btn btn--new-primary bright save-btn"
      disabled="true"
      [disabled]="saveDisabled$ | async"
      (click)="save()">
      <span class="btn__text">{{ 'GENERAL.SAVE' | translate }}</span>
    </button>
  </div>
</div>
